import { appAPI, ApiTags } from '.';

export interface InboxNotificationResponseFields {
  channelId: string;
  senderUserId: string;
  count: number;
  groupingEntityType?: string;
  notificationGroup?: string;
  itemName?: string;
}

export interface InboxNotificationResponse {
  id: string;
  object: string;
  data: string;
  createdAt: number;
  updatedAt: number;
  fields: InboxNotificationResponseFields;
}

export interface UpdateNotificationStatusBody {
  groupID: string;
  status: string;
}

export const inboxApi = appAPI.injectEndpoints({
  endpoints: build => ({
    getInboxNotifications: build.query<InboxNotificationResponse[], void>({
      query: () => ({
        path: '/notifications',
        method: 'get',
        options: {},
      }),
      providesTags: [ApiTags.inbox_notifications],
    }),
    updateInboxNotificationStatus: build.mutation<
      any,
      UpdateNotificationStatusBody
    >({
      query: ({ groupID, status }) => ({
        path: `/notifications?groupID=${groupID}`,
        method: 'put',
        options: {
          body: {
            status,
          },
        },
      }),
    }),
  }),
});

export const {
  useGetInboxNotificationsQuery,
  useUpdateInboxNotificationStatusMutation,
} = inboxApi;
